import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionTag, BigHead } from "./Reveal";

const FAQS = [
  { q: "What types of businesses do you work with?", a: "Small businesses, startups, and established brands with personality — restaurants, fitness studios, retail, realty, creatives, and anyone who refuses to look boring." },
  { q: "Do you work with clients outside my area?", a: "Absolutely. Most projects run remotely with video check-ins, shared boards, and fast feedback loops. Great design travels well." },
  { q: "How long does branding take?", a: "A full brand identity typically takes 3–6 weeks depending on scope. Logos alone can move faster; full brand systems with guidelines take a little longer to get right." },
  { q: "Do you offer website design?", a: "Yes — strategic, visually engaging websites designed to turn visitors into customers. Every site is custom, responsive, and built to be easy to update." },
  { q: "Do you offer ongoing website maintenance?", a: "Yes — three monthly tiers (Stay Live, Growth, and Elite Partner) keep your site fast, secure, and updated. Check the maintenance section above." },
  { q: "Can you help with printing?", a: "Definitely. Print is in the STAX DNA — business cards, flyers, brochures, signage, and packaging, all set up press-ready with correct color and bleed." },
  { q: "Do you offer social media design?", a: "Yes — templates, campaign graphics, and full visual systems so your feed stays consistent and unmistakably you." },
  { q: "How do I get started?", a: "Hit 'Start a Project', tell me about your business, and you'll get a reply within 1–2 business days with next steps and a quote." },
];

export const FAQ = ({ ch = "07" }) => (
  <section id="faq" data-testid="faq-section" className="relative bg-white py-24 sm:py-32 overflow-hidden">
    <div className="halftone absolute right-0 bottom-0 h-64 w-64 opacity-10 pointer-events-none" />
    <div className="relative mx-auto max-w-4xl px-4 sm:px-8">
      <div className="text-center">
        <Reveal><SectionTag color="bg-staxmagenta text-white" ch={ch}>FAQ</SectionTag></Reveal>
        <Reveal delay={0.08}>
          <BigHead className="mt-6">Questions?<br />Good. Ask<span className="text-staxcyan">.</span></BigHead>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 border-4 border-ink bg-paper shadow-hard">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`q-${i}`} className="border-b-2 border-ink/15 last:border-b-0 px-5 sm:px-7">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-left font-display uppercase text-base sm:text-lg text-ink hover:text-staxmagenta hover:no-underline [&>svg]:text-staxmagenta"
              >
                <span className="flex items-start gap-3">
                  <span className="font-mono2 text-xs font-bold text-staxcyan mt-1">{String(i + 1).padStart(2, "0")}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 pl-8 text-sm sm:text-base font-medium text-ink/65 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
